import * as React from "react";
import {Glyphicon, Row} from "react-bootstrap";
import ModalConfirmacion from "../../../general/componentes/ModalConfirmacion";
import {connect} from "react-redux";

class ModalMensajeBorrado extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        this.setState({show: true});
    }

    render() {
        return (
            <div>
                <Row>
                    <a title={"Ver mensaje"} className={"btns btns-primary"}
                       onClick={() => this.handleShow()}><Glyphicon glyph={"info-sign"}/></a>
                </Row>
                <Row>
                    <ModalConfirmacion titulo={"Documentos borrados"} show={this.state.show}
                                       onCancelar={() => this.handleClose()}>
                                    Señor usuario el tiempo para culminar su proceso de afiliación ha expirado, 
                                    el plazo máximo para entregar los documentos era de 30 días después de iniciado el trámite.
                                    Para poder entregar los documentos debe ingresar nuevamente al formulario en internet y completar todos los pasos.
                                    Aprovechamos para informarle que actualmente desde la misma página puede entregar los documentos en 
                                    forma virtual para que evite más desplazamientos y garantice mayor celeridad en el inicio de su cobertura.
                    </ModalConfirmacion>
                </Row>
            </div>
        );
    }

}

export default connect((store: any, props: any) => {
    return {
        ...props
    };
})(ModalMensajeBorrado);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/recepcion/ModalMensajeBorrado.tsx